// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { emptyTokenType, TokenType } from "features/config/types";

export type WalletReducer = {
  loading: boolean;

  address: string;
  publicKey: string;

  balance: string;

  networkName: string;
  networkUrl: string;
  networkType: string;
  validNetwork: boolean;

  isConnected: boolean;

  minting: boolean;
  isShowSuccessPopup: boolean;
  currentToken: TokenType;
  mintHash: string;

  referralCode: string;
};

export const defaultWalletReducer: WalletReducer = {
  loading: true,

  address: "",
  publicKey: "",

  balance: "0",

  networkName: "",
  networkUrl: "",
  networkType: "",
  validNetwork: false,

  isConnected: false,

  minting: false,
  isShowSuccessPopup: false,
  currentToken: emptyTokenType,
  mintHash: "",

  referralCode: "",
};
